import ContentLoader from 'react-content-loader'

type LoadMobileDepartamentsProps = {
  isMobile: boolean
}

export const LoadDepartaments: React.FC<LoadMobileDepartamentsProps> = ({
  isMobile,
}) => {
  if (isMobile) {
    return (
      <ContentLoader
        backgroundColor="#e0e0e0"
        foregroundColor="#ecebeb"
        height="938"
        id="load-departaments"
        speed={2}
        title="Carregando..."
        width="100%"
      >
        <rect x="0" y="0" rx="8" ry="8" width="60%" height="21" />
        <rect x="0" y="45" rx="8" ry="8" width="45.5%" height="45" />
        <rect x="54.5%" y="45" rx="8" ry="8" width="45.5%" height="45" />
        <rect x="0" y="112" rx="8" ry="8" width="55%" height="15" />
        <rect x="84%" y="105" rx="8" ry="8" width="16%" height="27" />
        <rect x="0" y="156" rx="8" ry="8" width="45.5%" height="200" />
        <rect x="0" y="370" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="394" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="421" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="447" rx="8" ry="8" width="24%" height="32" />
        <rect x="0" y="487" rx="8" ry="8" width="30%" height="15" />
        <rect x="0" y="544" rx="8" ry="8" width="45.5%" height="200" />
        <rect x="0" y="758" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="783" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="809" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="0" y="835" rx="8" ry="8" width="24%" height="32" />
        <rect x="0" y="875" rx="8" ry="8" width="30%" height="15" />
        <rect x="54.5%" y="156" rx="8" ry="8" width="45.5%" height="200" />
        <rect x="54.5%" y="370" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="394" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="421" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="447" rx="8" ry="8" width="24%" height="32" />
        <rect x="54.5%" y="487" rx="8" ry="8" width="30%" height="15" />
        <rect x="54.5%" y="544" rx="8" ry="8" width="45.5%" height="200" />
        <rect x="54.5%" y="758" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="783" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="809" rx="8" ry="8" width="45.5%" height="15" />
        <rect x="54.5%" y="835" rx="8" ry="8" width="24%" height="32" />
        <rect x="54.5%" y="875" rx="8" ry="8" width="30%" height="15" />
      </ContentLoader>
    )
  }

  return (
    <ContentLoader
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      height="938"
      id="load-departaments"
      speed={2}
      title="Carregando..."
      width="100%"
    >
      <rect x="0" y="0" rx="8" ry="8" width="25%" height="100%" />
      <rect x="27%" y="10" rx="8" ry="8" width="25%" height="21" />
      <rect x="27%" y="76" rx="8" ry="8" width="25%" height="15" />
      <rect x="29%" y="156" rx="8" ry="8" width="20%" height="200" />
      <rect x="29%" y="370" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="394" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="421" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="447" rx="8" ry="8" width="12%" height="32" />
      <rect x="29%" y="487" rx="8" ry="8" width="15%" height="15" />
      <rect x="29%" y="544" rx="8" ry="8" width="20%" height="200" />
      <rect x="29%" y="758" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="783" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="809" rx="8" ry="8" width="20%" height="15" />
      <rect x="29%" y="835" rx="8" ry="8" width="12%" height="32" />
      <rect x="29%" y="875" rx="8" ry="8" width="15%" height="15" />
      <rect x="54.5%" y="156" rx="8" ry="8" width="20%" height="200" />
      <rect x="54.5%" y="370" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="394" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="421" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="447" rx="8" ry="8" width="12%" height="32" />
      <rect x="54.5%" y="487" rx="8" ry="8" width="15%" height="15" />
      <rect x="54.5%" y="544" rx="8" ry="8" width="20%" height="200" />
      <rect x="54.5%" y="758" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="783" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="809" rx="8" ry="8" width="20%" height="15" />
      <rect x="54.5%" y="835" rx="8" ry="8" width="12%" height="32" />
      <rect x="54.5%" y="875" rx="8" ry="8" width="15%" height="15" />
      <rect x="77%" y="76" rx="8" ry="8" width="8%" height="15" />
      <rect x="86%" y="65" rx="8" ry="8" width="14%" height="40" />
      <rect x="80%" y="156" rx="8" ry="8" width="20%" height="200" />
      <rect x="80%" y="370" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="394" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="421" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="447" rx="8" ry="8" width="12%" height="32" />
      <rect x="80%" y="487" rx="8" ry="8" width="15%" height="15" />
      <rect x="80%" y="544" rx="8" ry="8" width="20%" height="200" />
      <rect x="80%" y="758" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="783" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="809" rx="8" ry="8" width="20%" height="15" />
      <rect x="80%" y="835" rx="8" ry="8" width="12%" height="32" />
      <rect x="80%" y="875" rx="8" ry="8" width="15%" height="15" />
    </ContentLoader>
  )
}
